import { grey } from '@material-ui/core/colors';

export default {
  suggestionListItemText: { marginLeft: '1rem' },
  eventDataIcon: { color: grey[600] },
};

